import React from "react";
import "../../styles/desktop/AlarmeModal.css";

import CaixaDaAguaPainel from "./CaixaDaAgua/CaixaDaAguaPainel";
import Bombas            from "./Bombas/Bombas";

export default function AlarmeModal({ caixas = [], bombas = [], status = "loading" }) {
  return (
    <div className="CampoAlarme">
      <h1 className="tituloCampo4">Alarmes Caixa D'àgua</h1>

      <div className="campoLegendaCaixadagua">
        {status === "loading" && (
          <p className="loadingServidor">Aguardando resposta do servidor…</p>
        )}
        {status === "error" && (
          <p className="erroServidor">Sem resposta do servidor — tentando novamente…</p>
        )}
        {status === "ok" && <CaixaDaAguaPainel caixas={caixas} />}
      </div>

      {/* Bombas / alarmes simples */}
      <div className="campoAlarmes">
        <Bombas bombas={bombas} />
      </div>
    </div>
  );
}
